<template>
    <div class="d-flex justify-content-end">
<!--        <div class="d-inline">
            <button class="text-decoration-none btn btn-sm icon icon-light mr-3"
                    @click="toggleExplorerHistory" title="history">
                <i class="fas fa-history"></i>
            </button>
        </div>-->
        <div class="d-inline">
            <button class="text-decoration-none btn btn-sm icon icon-light mr-3"
                    @click="showAppSettings">
                <i class="fas fa-cog"></i>
            </button>
        </div>
        <div class="d-inline">
            <LanguagePicker :guest="false"/>
        </div>
        <form class="frmSearchProduct" @submit="search">
            <input type="text" class="inputSearch" :placeholder="$t('components.topbar.search')"
                   v-model="searchText">
        </form>
        <button class="btn btn-sm icon icon-light mr-3 btnSearch" @click="search"><i class="fas fas fa-search"></i></button>
        <div class="d-inline" v-if="canChangeRealm">
            <RealmSelect/>
        </div>
        <div class="d-inline">
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none btn btn-sm icon icon-light mr-3"
                        no-caret :dropleft="true">
                <template v-slot:button-content>
                    <i class="fas fa-user-alt"></i>
                </template>
                <b-dropdown-item href="javascript:void(0)" @click="myAccount"><img class="img-fluid wacc-logo" :src="require('@/assets/wacc_logo.png')"/></b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#">{{$t('components.account.my-orders')}}</b-dropdown-item>
                <b-dropdown-item @click="logout">{{$t('components.account.logout')}}</b-dropdown-item>
            </b-dropdown>
        </div>
        <AppSettings v-show="appSettingsVisible" @close="closeAppSettings"/>
        <CartIcon/>
    </div>
</template>

<script>
import LanguagePicker from "../common/LanguagePicker";
import AppSettings from "./AppSettings";
import RealmSelect from "./RealmSelect";
import CartIcon from "./CartIcon";
import {empty} from "../../helpers";
import {EVENT_SEARCH} from "../../core/constants";

export default {
    name: "TopBar",
    components: {CartIcon, RealmSelect, AppSettings, LanguagePicker},

    mounted() {
        if (this.$route.name === 'app.search' && !empty(this.$route.query.value)) {
            this.searchText = this.$route.query.value;
            this.$watch('searchText', {
                immediate: false,
                handler: function (newVal) {
                    if (this.$route.name === 'app.search') {
                        this.$router.replace({query: {value: newVal}});
                    }
                }
            });
        }
    },

    data() {
        return {
            appSettingsVisible: false,
            searchText: null
        }
    },
    methods: {
        showAppSettings() {
            this.appSettingsVisible = true;
        },

        closeAppSettings() {
            this.appSettingsVisible = false;
        },

        logout() {
            this.$store.dispatch('authStore/logout').then(() => {
                let loader = this.$loading.show();
                this.$store.dispatch('categoryStore/clearCache')
                    .then(() => {
                        setTimeout(() => {
                            this.$router.push({name: 'app.guest'});
                            loader.hide();
                            loader = null;
                        }, 1000);
                    })
            });
        },

        search(e) {
            e.preventDefault();
            if (this.$route.name !== 'app.search') {
                if (!empty(this.searchText)) {
                    return this.$router.push({
                        name: 'app.search',
                        query: {
                            value: this.searchText
                        }
                    });
                }
            } else {
                this.$eventBus.$emit(EVENT_SEARCH, this.searchText);
            }
        },

        myAccount() {
            return window.open(this.$store.getters['authStore/getUrls'].user, '_blank')
        },

        /**
         * @disabled
         **/
        /* toggleExplorerHistory() {
             this.$eventBus.$emit('exploreHistoryComp::toggle');
         }*/
    },

    computed: {
        canChangeRealm() {
            return this.$store.getters['authStore/canChangeRealm'];
        },

        describeUser() {
            return `${this.$store.getters['authStore/getFullname']} - ${this.$store.getters['authStore/getCompanyName']}`;
        }
    }
}
</script>

<style scoped>

</style>
